"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var ReleaseItemPromosConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReleaseItemPromosConverter, _DataObjectConverter_);

  function ReleaseItemPromosConverter() {
    _classCallCheck(this, ReleaseItemPromosConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemPromosConverter).apply(this, arguments));
  }

  return ReleaseItemPromosConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReleaseItemPromosConverter = ReleaseItemPromosConverter;